import request from '@/utils/request'

export function getInfo (params) {
  return request({
    url: '/enterpriseInfo',
    method: 'GET',
    params
  })
}

export function getInfoList (params) {
  return request({
    url: '/enterpriseInfo/list',
    method: 'GET',
    params
  })
}

export function getCommitList (params) {
  return request({
    url: '/enterpriseInfo/commitList',
    method: 'GET',
    params
  })
}

export function updateInfo (data) {
  return request({
    url: '/enterpriseInfo',
    method: 'POST',
    data
  })
}

export function getRevenueList (userId) {
  return request({
    url: `/enterpriseRevenue/${userId}`,
    method: 'GET'
  })
}

export function getRevenueNewList (userId) {
  return request({
    url: `/enterpriseRevenue/new/${userId}`,
    method: 'GET'
  })
}

export function getRevenueBaseInfoList (userId) {
  return request({
    url: `/enterpriseRevenue/baseInfo/${userId}`,
    method: 'GET'
  })
}

export function addRevenueList (data) {
  return request({
    url: '/enterpriseRevenue',
    method: 'POST',
    data
  })
}

export function syncHistory (data) {
  return request({
    url: '/enterpriseInfoHistory',
    method: 'PUT',
    data
  })
}

export function getEvaluate (params) {
  return request({
    url: '/evaluate',
    method: 'GET',
    params
  })
}

export function getScenes (params) {
  return request({
    url: '/scence',
    method: 'GET',
    params
  })
}

export function getAnswerList (params) {
  return request({
    url: '/answerInfo',
    method: 'GET',
    params
  })
}

export function getOwnerAnswer (userId) {
  return request({
    url: `/answerInfoOwner/${userId}`,
    method: 'GET'
  })
}

export function getSceneAnswer (params) {
  return request({
    url: '/sceneAnswer',
    method: 'GET',
    params
  })
}

export function getOwnerSceneAnswer (userId) {
  return request({
    url: `/sceneAnswerOwner/${userId}`,
    method: 'GET'
  })
}

export function getAnswerPivot (params) {
  return request({
    url: '/verb',
    method: 'GET',
    params
  })
}

export function addPivot (data) {
  return request({
    url: '/verb',
    method: 'POST',
    data
  })
}

export function addAnswer (data) {
  return request({
    url: '/answerInfo',
    method: 'POST',
    data
  })
}

export function addSceneAnswer (data) {
  return request({
    url: '/sceneAnswer',
    method: 'POST',
    data
  })
}

export function addOwnerAnswer (data) {
  return request({
    url: '/answerInfoOwner',
    method: 'POST',
    data
  })
}

export function addOwnerSceneAnswer (data) {
  return request({
    url: '/sceneAnswerOwner',
    method: 'POST',
    data
  })
}

export function getDeclaration (userId) {
  return request({
    url: `/declaration/${userId}`,
    method: 'GET'
  })
}

export function getOwnerDeclaration (userId) {
  return request({
    url: `/declarationOwner/${userId}`,
    method: 'GET'
  })
}

export function addDeclaration (data) {
  return request({
    url: '/declaration',
    method: 'POST',
    data
  })
}

export function fixDeclaration (data) {
  return request({
    url: '/declaration/commitAll',
    method: 'POST',
    data
  })
}

export function addOwnerDeclaration (data) {
  return request({
    url: '/declarationOwner/commitAllOwner',
    method: 'POST',
    data
  })
}

export function resetOwnerDeclaration () {
  return request({
    url: '/declarationOwner/reset',
    method: 'GET'
  })
}

export function getFile (id) {
  return request({
    url: `/minio/${id}`,
    method: 'GET',
    timeout: 1000000,
    responseType: 'blob'
  })
}

export function getExpert () {
  return request({
    url: '/staff/expert',
    method: 'GET'
  })
}

export function makeExportExcel (data) {
  return request({
    url: '/enterpriseInfo/export',
    method: 'POST',
    data
  })
}

export function makeInfosExcel () {
  return request({
    url: '/enterpriseInfo/exportAll',
    method: 'POST'
  })
}

export function makeExpertExcel (ids) {
  return request({
    url: `/enterpriseInfo/exportVerb?ids=${ids}`,
    method: 'POST'
  })
}

export function addDistribute (data) {
  return request({
    url: '/distributeEnterprise',
    timeout: 100000,
    method: 'POST',
    data
  })
}

export function addReport (data) {
  return request({
    url: '/exportReport',
    method: 'POST',
    data
  })
}

export function getReport (enterpriseId) {
  return request({
    url: `/exportReport/${enterpriseId}`,
    method: 'GET'
  })
}

export function getManagerReport (enterpriseId) {
  return request({
    url: `/exportReport/manager/${enterpriseId}`,
    method: 'GET'
  })
}

export function getAvgData () {
  return request({
    url: '/declaration/backRedisAvgData',
    method: 'GET'
  })
}

export function patchIssue (userId) {
  return request({
    url: `/declaration/issue/${userId}`,
    method: 'POST'
  })
}
